<template>
  <div>
    <div class="page f-pr">
      <img src="../assets/dk.png" alt="">


      <img class="btn-back" src="../assets/back.png" alt="" @click="back()">
      <!-- <div class="btn-back" @click="back()"></div> -->




      <!-- 5个印章 -->
      <div class="box-item box-item-1" :class="{ 'light': taskConfig.part1.status }" @click="openPopup(taskConfig.part1)">
        <img src="../assets/yz1.png" v-if="taskConfig.part1.status" alt="">
        <div class="p"></div>
      </div>

      <div class="box-item box-item-2" :class="{ 'light': taskConfig.part2.status }" @click="openPopup(taskConfig.part2)">
        <img src="../assets/yz2.png" v-if="taskConfig.part2.status" alt="">
        <div class="p"></div>
      </div>


      <div class="box-item box-item-3" :class="{ 'light': taskConfig.part3.status }" @click="openPopup(taskConfig.part3)">
        <img src="../assets/yz3.png" v-if="taskConfig.part3.status" alt="">
        <div class="p"></div>
      </div>


      <div class="box-item box-item-4" :class="{ 'light': taskConfig.part4.status }" @click="openPopup(taskConfig.part4)">
        <img src="../assets/yz4.png" v-if="taskConfig.part4.status" alt="">
        <div class="p"></div>
      </div>
      <div class="box-item box-item-5" :class="{ 'light': taskConfig.part5.status }" @click="openPopup(taskConfig.part5)">
        <img src="../assets/yz5.png" v-if="taskConfig.part5.status" alt="">
        <div class="p"></div>
      </div>
      <div class="box-item box-item-6" :class="{ 'light': taskConfig.part6.status }" @click="openPopup(taskConfig.part6)">
        <img src="../assets/yz6.png" v-if="taskConfig.part6.status" alt="">
        <div class="p"></div>
      </div>

      <div class="box-button-6" v-show="taskList.length >= 6" >
        <img src="../assets/go-lottery.png" alt=""  @click="goLottery()">
      </div> 
      
      <div :class="[ taskList.length >= 6?'box-button-7':'box-button-7-new' ]">
        <img src="../assets/rule.png" alt="">
      </div>





      <van-overlay :show="showLoading" z-index="999">
        <div class="fcc-h " style="height: 100vh;">
          <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
        </div>
      </van-overlay>

      <van-overlay :show="showPopSign" z-index="999" @click="showPopSign = !showPopSign" @touchstart="handleTouchStart">
        <div class="fcc-h gz-pop" style="height: 100vh; overflow: auto;">
          <div class="f-pr gz-pop-con fcc-h" @click.stop=''>
            <div class="fcc">
              <!-- <img src="../assets/yqjzb.png" alt="" class="img1"> -->
            </div>



            <!-- 盖章区域 -->
            <div class="gz-area fcc ">
              <img src="../assets/gzq.png" alt="">
            </div>


            <!-- <div class="gz-tips fcc">
              <img src="../assets/zcgz.png" alt="">
            </div> -->
            <div class="fix-btn" @click="showPopSign = !showPopSign">

              <!-- <van-icon name="cross" size="36" color="#fff" /> -->
            </div>
          </div>
        </div>
      </van-overlay>

      <van-overlay :show="showResult" z-index="999" @click="showResult = !showResult" style="background-color: rgba(0, 0, 0, 0.3);" >
        <div class="fcc-h gz-pop" style="height: 100vh; overflow: auto;">
          <div class="f-pr gz-pop-con fcc-h" @click.stop=''>
            <div class="fcc">
              <!-- <img src="../assets/yqjzb.png" alt="" class="img1"> -->
            </div>


            <div class="gz-area fcc ">
              <img src="../assets/congratulations.png" style="width: 100%; height: auto; margin-top: -500px;" alt="">
            </div>

            <div class="fix-btn" @click="showResult = !showResult">

              <!-- <van-icon name="cross" size="36" color="#fff" /> -->
            </div>
          </div>
        </div>
      </van-overlay>

     
      <div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
        <audio id="audioID" ref="audio" class="aud">
          <source src="https://park.warnny.com/duang.mp3" type="audio/mp3" />
        </audio>
      </div>


    </div>
  </div>
</template>

<script>
import {
  checkTask,
  login,
  getGift
} from "@/api/api";
import {
  check
} from "@/utils/check"
import CryptoJS from 'crypto-js'
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      showResult: false,
      showLoading: false,
      showPopSign: false,
      showGift: false,
      showGiftImg: 0,
      userInfo: {},
      uid: null,
      taskConfig: {
        part1: {
          name: "part1",
          status: false
        },
        part2: {
          name: "part2",
          status: false
        },
        part3: {
          name: "part3",
          status: false
        },
        part4: {
          name: "part4",
          status: false
        },
        part5: {
          name: "part5",
          status: false
        },
        part6: {
          name: "part6",
          status: false
        }
      },
      currentItem: {},
      command: '',
      taskList:[]
    }
  },

  async mounted() {
    let self = this
    // self.showLoading = true
    this.uid = window.localStorage.getItem('agmUnionId')
    if (this.uid && this.uid != 'null' && this.uid != 'undefinded') {
      this.login(this.uid)
    } else {
      this.$router.push({ path: '/' })
      return
    }
    this.$nextTick(() => {
      let Media = document.getElementById("audioID");
      Media.src = "https://activity.warnny.com/duang.mp3";
    })
  },

  methods: {
    login(uid) {
      let self = this
      // self.showLoading = true
      self.taskList = []
      login({
        username: uid
      }).then(res => {
        if (res.status != 200) {
          this.$toast(res.msg)
          return
        } else {
          window.localStorage.setItem('agmUnionId', res.data.userInfo.username)
          self.uid = res.data.userInfo.username
          self.userInfo = res.data.userInfo
          let taskList = res.data.userInfo.taskList
          self.taskList = taskList
          for (let i = 0; i < taskList.length; i++) {
            self.taskConfig[taskList[i].taskName].status = true
          }
        }
      }).finally(f => {
        self.showLoading = false
      })
    },
    goLottery() {
      // this.$toast("goLottery")
      if (this.taskList.length < 6) {
        this.$toast("集满所有印章才能抽奖哦~")
        return
      }
      // 跳转外部链接
      window.location.href = 'https://ts-cwagm.ban020.com/gza.php?uid=' + this.uid
    },
    openPopup(item) {
      this.currentItem = item
      if (this.currentItem.status) {
        return
      }
      this.showPopSign = true
    },
    async handleTouchStart(event) {
      let that = this;
      if (that.currentItem.status) {
        return
      }
      if (event.touches.length != 5 && event.touches.length != 4) {
        return
      }
      // if (this.gaizhangCount > 5) {
      //   that.$toast("盖章失败次数达5次，请输入口令")
      //   return
      // }
      let timestamp = new Date().getTime();
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      // let scope = check(touchArr)
      let scope = true
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        let request = {
          taskName: that.currentItem.name,
          timestamp: timestamp,
          userId: this.uid,
          type: this.type,
          array: touchArr,
        }
        let md5Result = CryptoJS.MD5(request.taskName + request.timestamp + request.userId).toString();
        request.sign = md5Result
        request.method = 1
        checkTask(request).then(res => {
          if (res && res.msg) {
            this.$toast(res.msg)
            this.checking = false
          } else if (res) {
            that.showPopSign = false
            that.showResult = true
            that.$toast("打卡成功")
            document.querySelector('audio').play()
            document.getElementById("audioID").play()
            this.checking = false
            setTimeout(function () {
              that.login(that.uid)
            }, 1200)
          } else {
            if (res.msg) {

              that.$toast("打卡失败，请重试")
              this.checking = false
            }
          }
        })
      }
    },
  }



}
</script>
<style scoped lang="less">
.page {
  display: block;

  min-height: 100vh;
  // background: #FFE5EE url(../assets/bg-1.png) center 0 no-repeat;
  background-size: cover;
  // background-size: cover;
  position: relative;

  >img {
    display: block;
    width: 100%;
  }
}

.btn-back {
  position: absolute;
  left: 38px;
  top: 88px;
  width: 108px !important;
  height: 38px !important;
  // background: rgba(255, 0, 0, 0.5);
  // background: url(../assets/back.png) center 0 no-repeat;
  z-index: 10;
}

.gz-area {
  width: 700px;

  img {
    width: 579px;
    height: 579px;
  }
}

.box-item {
  position: absolute;
  z-index: 5;
  width: 225px;
  height: 225px;
  // 图片变灰色
  // filter: grayscale(100%);
  // opacity: .9;

  &.light {
    filter: grayscale(0%);
    opacity: 1;
  }

  img {
    display: block;

    width: 100%;
    display: block;
    height: 100%;

  }


  left: 362px;
  top: 158px;

  .p {
    position: absolute;
    height: 34px;
    width: 100%;
    left: 0;
    top: 100%;
    margin-top: 4px;
    // background: url(../assets/yz1-t.png) center no-repeat;
    background-size: contain;
  }

  &-2 {
    left: 66px;
    top: 260px;

    .p {
      // background-image: url(../assets/yz2-t.png);
    }
  }

  &-3 {
    left: 89px;
    top: 586px;

    .p {
      // background-image: url(../assets/yz3-t.png);
    }
  }


  &-4 {
    left: 348px;
    top: 763px;

    .p {
      // background-image: url(../assets/yz4-t.png);
    }
  }


  &-5 {
    left:427px;
    top: 1068px;

    .p {
      // background-image: url(../assets/yz5-t.png);
    }
  }
  
  &-6 {
    left: 68px;
    top: 1061px;

    .p {
      // background-image: url(../assets/yz5-t.png);
    }
  }
}

.box-button-6 {
  position: absolute;
  z-index: 99999;
  width: 418px;
  height: 128px;

  img {
    display: block;

    width: 100%;
    display: block;
    height: 100%;

  }

  left: 168px;
  top: 1358px;
}

.box-button-7 {
  position: absolute;
  z-index: 5;
  width: 656px;
  height: 433px;

  img {
    display: block;

    width: 100%;
    display: block;
    height: 100%;

  }

  left: 47px;
  top: 1473px;
}

.box-button-7-new{
  position: absolute;
  z-index: 5;
  width: 656px;
  height: 433px;

  img {
    display: block;

    width: 100%;
    display: block;
    height: 100%;

  }

  left: 47px;
  top: 1338px;
}


.gif-img {
  width: 510px;
  display: block;
}

.gif-x {
  width: 80px;
  height: 100px;
  // background: rgb(255, 0, 0);
  position: absolute;
  right: 0;
  top: 20px;
  opacity: .5;
}
</style>